module.exports = __webpack_public_path__ + "media/images/redesign-images/graduate-program/grad-02-81c05b007e3304c511669c30953d410d.webp";